<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary"
            >
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewData" class="btn btn-primary">
              Create Special Prize
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                Brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item"
                >
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="prize_type_id_column" slot-scope="props">
            <label v-if="props.cell_value == 1">
            Coins
            </label>
            <label v-if="props.cell_value == 2">
            Raffle Entries
            </label>
            <label v-if="props.cell_value == 3">
            Mobile Load
            </label>
            <label v-if="props.cell_value == 4">
            Voucher
            </label>
            <label v-if="props.cell_value == 5">
            Items
            </label>
             <label v-if="props.cell_value == 6">
            No Reward
            </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.sku_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Special Prize Condition Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select merchant item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="SKU"
              input-classes="form-control"
              v-model="specialPrizeModel.sku"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="SKU Name"
              input-classes="form-control"
              v-model="specialPrizeModel.sku_name"
            />
          </div>
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label"> Start End Date </label>
              <date-picker
                v-model="validDateRange"
                range
                editable
                clearable
                value-type="YYYY-MM-DD"
                id="ValidDateRange"
                :default-value="validDateRange"
                style="width: 100%"
                :disabled="isDisabledUpdate"
              ></date-picker>
            </div>
          </div>
        </div> 
        <div class="row">
          <div class="col-lg-12">
            <label class="form-control-label">
                Upload Images
            </label>
            <base-input type="file" id="file-input" accept="image/*" multiple @change="onFileChange($event)"/>
            <div id="preview-container">
              <div v-for="(file, index) in files" :key="index" class="preview">
                <img :src="file.targetUrl" class="img img-thumbnail">
                <button class="delete" @click="removeFile(index)">Delete</button>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <label class="form-control-label"> Prize </label>
            <multiselect
              v-model="PrizeValues"
              tag-placeholder="Add this as Prize"
              placeholder="Search or add Prize"
              label="prize_name"
              track-by="id"
              :options="PrizesOptions"
              :multiple="true"
              :taggable="true"
              @remove="unSelectMjrPrize"
            >
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdateData"
          class="btn btn-primary"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import NProgress from "nprogress";

export default {
  name: "productsList",
  data() {
    return {
      is_allowed_create: false,
      is_loads3presigned: false,
      watch_brand_code: "PHFortune",
      uploadModel: {
        imageUrl: null,
        imagePresignedUrl: "",
        imageFile: null,
      },
      deleteMessages: [],
      PrizesOptions: [],
      PrizeValues: [],
      unSelectedMjrPrize:[],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      isBrandCodeDisabled: false,
      isDisabledUpdate: false,
      brandCodeOption: [],
      DateRangeModel: null,
      validDateRange: [],
      files:[],
      prizeTypeList: [
        { text: "Coins", value: "1" },
        { text: "Raffle Entries", value: "2" },
        { text: "Mobile Load", value: "3" },
        { text: "Voucher", value: "4" },
        { text: "Items", value: "5" },
        { text: "No Reward", value: "6" },
      ],
      titlePopup: "Create",
      message: null,
      specialPrizeModel: {
        brand_code: "PHFortune",
        sku: 0,
        sku_name: "",
        image_urls: [],
        start_date: "",
        end_date:"",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        prize_ids : [],
      },
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allData: null,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brand_code",
          sort: true,
        },
        {
          label: "SKU",
          name: "sku",
          sort: true,
        },
        {
          label: "SKU Name",
          name: "sku_name",
          sort: true,
        },
        {
          label: "Start Date",
          name: "start_date",
          sort: true,
        },
        {
          label: "End Date",
          name: "end_date",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    this.onRefreshData();
    this.isBrandCodeDisabled = false;
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('specialprizeconditionconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('specialprizeconditionconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    ValidateForm() {
      if (
        this.specialPrizeModel.brand_code &&
        this.specialPrizeModel.sku &&
        this.specialPrizeModel.sku_name &&
        this.specialPrizeModel.image_url 
      ) {
        return true;
      }
      return false;
    },
    resetMessage(){
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.specialPrizeModel = {
        brandCode: "PHFortune",
        sku: "",
        sku_name: "",
        image_urls : [],
        start_date: "",
        end_date:"",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
      };
      this.uploadModel = {
        imageUrl: "",
        imagePresignedUrl: "",
        imageFile: null,
      };
      this.files = [];
      this.isBrandCodeDisabled=false;
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let EndDate= momNow.add(1, "months").format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format(
        "YYYY-MM-DD"
      );
      let momEnd = this.$moment(new Date(EndDate)).format(
        "YYYY-MM-DD"
      );
      this.specialPrizeModel.start_date = momStart;
      this.specialPrizeModel.end_date = momEnd;
      this.validDateRange = [momStart, momEnd];
    },
    onCreateNewData() {
      this.PrizeValues = []
        NProgress.start();
        api_loyalty
          .GetAllPrizesByBrandCode(this.watch_brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.PrizesOptions = data.data;
              NProgress.done();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.onResetForm();
      this.isBrandCodeDisabled = false;
    },
    toggleActive() {},
    async onRefreshData() {
      if(this.showModalCreate){
        this.PrizeValues = []
        NProgress.start();
        api_loyalty
          .GetAllPrizesByBrandCode(this.watch_brand_code)
          .then((data) => {
            if(data.isSuccess){
              this.PrizesOptions = data.data;
              NProgress.done();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      api_loyalty
        .GetAllSpecialPrizeConditionConfig(this.watch_brand_code)
        .then((data) => {
          try {
            if(data.isSuccess)
            {
              this.rows = data.data;
              this.allData = data.data;
            }
          } catch (e) {
            console.log(e);
          }
      });
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.files = [];
      this.specialPrizeModel = this.allData.filter(
        (x) => x.id === this.selectedItems[0].id)[0];
      let prizes = [];
      
      api_loyalty
        .GetAllPrizesByBrandCode(this.specialPrizeModel.brand_code)
        .then((data) => {
          if(data.isSuccess){
            this.PrizesOptions = data.data;
            this.specialPrizeModel.prize_ids.forEach(function (item) {
              var prize = data.data.filter((x) => x.id === item)[0];
              if(prize){
                prizes.push(prize);
              }
            });
            this.PrizeValues = prizes;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      
      this.specialPrizeModel.image_urls.forEach((element) => {
        var data = {
         url: element.image_url,
         targetUrl: element.image_url,
         type : 'image',
        }
        this.files.push(data)
      })

      this.validDateRange = [this.specialPrizeModel.start_date, this.specialPrizeModel.end_date];
      this.showModalCreate = true;
      this.titlePopup = "Update";
      this.isBrandCodeDisabled = true;
      if(this.validDateRange[0]==null || this.validDateRange[1] == null){
        let momNow = this.$moment(new Date().toUTCString());
        let StartDate = momNow.format("YYYY-MM-DD");
        let EndDate= momNow.add(1, "months").format("YYYY-MM-DD");
        let momStart = this.$moment(new Date(StartDate)).format(
          "YYYY-MM-DD"
        );
        let momEnd = this.$moment(new Date(EndDate)).format(
          "YYYY-MM-DD"
        );
        this.specialPrizeModel.start_date = momStart;
        this.specialPrizeModel.end_date = momEnd;
        this.validDateRange = [momStart, momEnd];
      }
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        this.specialPrizeModel.id = deleteRequest.id;
        api_loyalty
          .DeleteSpecialPrizeConditionConfig(this.specialPrizeModel.brand_code, this.specialPrizeModel)
          .then((response) => {
            this.onRefreshData();
            var popupType = "success"
            if(response.isSuccess == false){
              popupType = "danger";
            }

            let msg = {
              message: "Success Delete: " + element.sku_name,
              type: popupType,
            };
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete '" +
                element.sku_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }

            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    async createUpdateData() {
      if(this.validDateRange.length > 1){
        this.specialPrizeModel.start_date = this.validDateRange[0];
        this.specialPrizeModel.end_date = this.validDateRange[1];
        
      api_loyalty.GetTimeZoneConfig(this.watch_brand_code).then((data) => {
      try {
            if(data.isSuccess)
            {
                var start_date = new Date(this.validDateRange[0]);
                start_date.setHours( start_date.getHours() + (data.data.value * -1));
                var end_date = new Date(this.validDateRange[1]);
                end_date.setHours( end_date.getHours() + (data.data.value * -1));
                this.specialPrizeModel.start_date = start_date;
                this.specialPrizeModel.end_date = end_date;
            }
            let prize_items = [];
            this.PrizeValues.forEach(function (item) {
              prize_items.push(item.id);
            });
            this.specialPrizeModel.prize_ids = prize_items;
            if (this.files.length > 0) {
              this.files.forEach((f) => {
                const exists = this.specialPrizeModel.image_urls.some(
                (image) => image.image_url === f.url
              );
              if(!exists) {
                var data = {
                    image_url: f.url,
                  };
                this.specialPrizeModel.image_urls.push(data);  
                }  
              });
            }

            if (this.specialPrizeModel.id) {
              this.specialPrizeModel.modify_date = new Date().toISOString();
              this.specialPrizeModel.brand_code = this.watch_brand_code;
              api_loyalty
              .UpdateSpecialPrizeConditionConfig(this.specialPrizeModel.brand_code, this.specialPrizeModel)
              .then((response) => {
                this.onRefreshData();
                var popupType = "success"
                if(response.isSuccess == false){
                  this.message = {
                    message: "Failed to Update data.",
                    type: "danger",
                  };
                }else{
                  this.message = {
                    message: "Success to Update data.",
                    type: popupType,
                  };
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response && e.response.status === 401)
                {
                  this.message = {
                    message: "You don't have a permission",
                    type: 'danger'
                  }
                } else
                {
                  this.message = {
                    message: "Failed to update rules Item Config.",
                    type: "danger",
                  }
                }                
              });
            } else {
              this.specialPrizeModel.brand_code = this.watch_brand_code;
              this.specialPrizeModel.create_date = new Date().toISOString();
              this.specialPrizeModel.modify_date = new Date().toISOString();
              api_loyalty
              .CreateSpecialPrizeConditionConfig(this.specialPrizeModel.brand_code, this.specialPrizeModel)
              .then((response) => {
                this.onRefreshData();
                var popupType = "success"
                if(response.isSuccess == false){
                  this.message = {
                  message: "Failed to create data.",
                  type: "danger",
                  };
                }else{
                  this.message = {
                    message: "Success to create data.",
                    type: popupType,
                  };
                }
              })
              .catch((e) => {
                console.log(e);
                if (e.response && e.response.status === 401)
                {
                  this.message = {
                    message: "You don't have a permission",
                    type: 'danger'
                  }
                } else
                {
                  this.message = {
                    message: "Failed to create data.",
                    type: "danger",
                  }
                }
              });
            }
            
            this.files.forEach(x => {
              api_loyalty.S3PutObject(
                x.presignedUrl,
                x.file
              );
            })

            this.onResetForm();
            this.showModalCreate = false;          
          } catch (e) 
          {
            this.message = {
              message: "Failed to add/update Product catalog.",
              type: "danger",
            };
          }
        });
      }
    },
    onFileChange(event) {
      const selectedFiles = event.target.files;
      if (!selectedFiles.length) return;

      selectedFiles.forEach((file) => {
        this.files.push({
            file: file,
            url: '',
            targetUrl: '',
            presignedUrl: '',
            type : 'image'
          });
        const reader = new FileReader();
        reader.onload = (e) => {
          this.is_loads3presigned = true;
          let fileData = this.files.find(f => f.file == file);
          fileData.targetUrl = e.target.result;
          api_loyalty
          .GenerateS3PresignedUploadUrl(
            "giftaway-catalog-image",
            file,
            this.specialPrizeModel.sku_name +
              "_" +
              'image' +
              "_" +
              this.specialPrizeModel.id,
              this.watch_brand_code
          )
          .then((data) => {
            try {
              if(data.isSuccess)
              {
                fileData.presignedUrl = data.data.s3Object.uploadUrl;
                fileData.url = data.data.s3Object.cdnUrl;
              }
            } catch (e) {
              console.log(e);
            }
            this.is_loads3presigned = false;
          });
        };
        reader.readAsDataURL(file);
      })
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.specialPrizeModel.image_urls.splice(index, 1);
    },
    unSelectMjrPrize({id}){
      if(this.unSelectedMjrPrize.indexOf(id) == -1){
        this.unSelectedMjrPrize.push(id);
        this.specialPrizeModel.prize_ids.push(id);
      }
    }
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    Multiselect,
  },
  watch: {
    watch_brand_code: function() {
      this.specialPrizeModel.brand_code = this.watch_brand_code;
      this.onRefreshData();
    },
  },
  computed: {}
};
</script>
<style scoped>
.preview {
  display: inline-block;
  margin: 5px;
}
.preview img {
  max-width: 100px;
  max-height: 100px;
  display: block;
}
.delete {
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  display: block;
  margin-top: 5px;
}
</style>
